import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Box, Grid, Typography } from '@mui/material'
import { format } from 'date-fns'

import { useGET_announcementsQuery } from 'redux/api/announcementsApi'
import { toggleAnnouncements } from 'redux/ui/sidebarUI'

import LoadingLabel from 'components/atoms/loaders/LoadingLabel'

import { ELEMENT_RADIUS } from 'utils/customizedTheme'

import pin from 'assets/images/student/pin.png'

const AnnouncementsList: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { isFetching, data, isError } = useGET_announcementsQuery({ page: 1 })

  return (
    <Box sx={{ }} p={3}>
      {data?.results.length > 0 &&
        data?.results?.map(
          (announcement) =>
            announcement.actions.is_viewable && (
              <Box
                key={announcement.id}
                sx={{
                  borderRadius: ELEMENT_RADIUS,
                  width: '100%',
                  background: '#e6f4d5',
                  marginBottom: '20px',
                  boxShadow: 'rgba(0, 0, 0, 0.3) 0px 3px 8px'
                }}
                p={3}
              ><Box sx={{ borderBottom: '1px solid #000', paddingBottom: '0.5rem', marginBottom: '1rem', position: 'relative' }}>
                  <img src={pin} width={50} style={{ position: 'absolute', top: '-50px', right: '-40px' }} alt="pin"/>
                  <Grid container>
                    <Grid item>
                      <Typography sx={{ fontWeight: '400', fontSize: '0.9rem', '& p': { margin: '0.1rem 0' } }}>
                        {t('common.on')}:{' '}
                        {announcement.created_at ? format(new Date(announcement.created_at), 'yyyy-MM-dd') : ''}
                      </Typography>
                      <Typography sx={{ fontWeight: '400', fontSize: '0.9rem', '& p': { margin: '0.1rem 0' } }}>
                        {t('common.by')}: {announcement.creator}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                <Box sx={{ marginBottom: '20px' }}>
                    <Typography
                      sx={{ fontWeight: '500', fontSize: '0.9rem', '& p': { margin: '0.1rem 0' } }}
                      dangerouslySetInnerHTML={{
                        __html: announcement.text+'...',
                      }}
                    />
                </Box>
                <Box>
                  <Typography
                    onClick={() => {
                      navigate(`/announcements/view/${announcement.id}`)
                      dispatch(toggleAnnouncements())
                    }}
                    sx={{
                      fontSize: '1rem',
                      color: '#333',
                      textAlign: 'right',
                      cursor: 'pointer',
                      '&:hover': { textDecoration: 'underline', color: 'inherit' },
                    }}
                  >
                    {`${t('common.view-more')}...`}
                  </Typography>
                </Box>
              </Box>
            ),
        )}
      {isFetching && <LoadingLabel />}
      {isError && <div className='info-text'>{`◽ ${t('loading-table-data-error')} ◽`}</div>}
      {data?.results.length === 0 && !isFetching && !isError && (
        <div className='info-text'>{`◽ ${t('no-items-found')} ◽`}</div>
      )}
    </Box>
    
  )
}
export default AnnouncementsList
